import { render, staticRenderFns } from "./Troubleshoot.vue?vue&type=template&id=6c3a7bed&scoped=true"
import script from "./Troubleshoot.vue?vue&type=script&lang=js"
export * from "./Troubleshoot.vue?vue&type=script&lang=js"
import style0 from "./Troubleshoot.vue?vue&type=style&index=0&id=6c3a7bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a7bed",
  null
  
)

export default component.exports